export const CREATE_FILE_METADATA = 'CREATE_FILE_METADATA'
export const CREATE_FILE_METADATA_FAILED = 'CREATE_FILE_METADATA_FAILED'
export const CREATE_FILE_METADATA_SUCCEEDED = 'CREATE_FILE_METADATA_SUCCEEDED'

export const FETCH_S3_PRESIGNED_URLS = 'FETCH_S3_PRESIGNED_URLS'
export const FETCH_S3_PRESIGNED_URLS_SUCCEEDED = 'FETCH_S3_PRESIGNED_URLS_SUCCEEDED'

export const INCREMENT_LAST_UPLOAD_ID = 'INCREMENT_LAST_UPLOAD_ID'
export const RESET_FILE_UPLOAD_STORE = 'RESET_FILE_UPLOAD_STORE'

export const UPLOAD_FILES = 'UPLOAD_FILES'
export const UPLOAD_FILES_FAILED = 'UPLOAD_FILES_FAILED'
export const UPLOAD_FILES_PROGRESS = 'UPLOAD_FILES_PROGRESS'
export const UPLOAD_FILES_SUCCEEDED = 'UPLOAD_FILES_SUCCEEDED'

export const UPLOAD_ATTACHMENTS = 'UPLOAD_ATTACHMENTS'
export const UPLOAD_ATTACHMENTS_FAILED = 'UPLOAD_ATTACHMENTS_FAILED'
export const UPLOAD_ATTACHMENTS_SUCCEEDED = 'UPLOAD_ATTACHMENTS_SUCCEEDED'
